import "@babel/polyfill";
import './public-path';
import { setContext } from "./monitoring/monitoring";
import { initLoggerFactory, eLogLevel, createLogger } from "@888webteam/logger-core";
import { ConsoleLoggerFactory } from "@888webteam/logger-console";
import { zoidCreate } from './zoidComponent'
import './assets/scss/Registration.scss';
import { BankIdLogic } from "./BankIdLogic";

initLoggerFactory(new ConsoleLoggerFactory(eLogLevel.Debug));

global.init = function (backendModel) {

    let logger = createLogger("BankIdAuthenticatorApp");

    logger.log("using BankIdAuthenticator", VERSION);

    zoidCreate(backendModel);

    let onSuccess = global.xprops.settings.events.onSuccess || function () { };
    let onSuccessWithExtraData = global.xprops.settings.events.onSuccessWithExtraData || function () { };
    let onBack = global.xprops.settings.events.onBack || function () { };
    let onLoad = global.xprops.settings.events.internalOnLoad || function () { };
    let onErrorDisplayed = global.xprops.settings.events.onErrorDisplayed || function () { };
    let onTestBankIdInserted = global.xprops.settings.events.onTestBankIdInserted || function () { };
    let openBankId = global.xprops.settings.events.openBankId || function () { };    

    setContext(global.xprops.settings.context);

    let bankIdLogic = new BankIdLogic(global.xprops.settings.context, __webpack_public_path__, backendModel.isMobile, backendModel.useSecuredFlow)
        .onSuccess(function (token) {
            onSuccess(token);
        })
        .onSuccessWithExtraData(function (data) {
            onSuccessWithExtraData(data);
        })
        .onBack(function () {
            onBack();
        })
        .onErrorDisplayed(function (code, msg) {
            onErrorDisplayed(code, msg);
        })
        .onTestBankIdInserted(function () {
            onTestBankIdInserted();
        })
        .openBankId(function (url, autoStartToken) {
            backendModel.isMobile === true && openBankId(url, autoStartToken);
        });

    onLoad({
        reset: function () {
            bankIdLogic.reset();
        },

        showError: function (err) {
            bankIdLogic.showError(err);
        },

        showGeneralError: function () {
            bankIdLogic.showGeneralError();
        },

        clearErrors: function () {
            bankIdLogic.clearErrors();
        }
    });
}